/**
 * Utils for converting rem to px
 *
 * Works correctly even when the user has increased the font size in
 * their browser. Can do it [here][1] in chrome.
 *
 * [1]: chrome://settings/?search=font+size
 */

function getPxPerRem() {
  if (typeof window === "undefined") {
    return 10;
  }

  const pxStr = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue("font-size")
    .match(/\d+/)?.[0];

  return pxStr === undefined ? 10 : Number(pxStr);
}

/*
 * Recommeneded usage is to memoize result, either on top level or using
 * a React hook, to aovid calling this on every render.
 *
 * (When using React hook intead of top level memoization, re-mounting
 * the component will update the memoized value.)
 */
export const remToPx = (rem: number): number => getPxPerRem() * rem;
